import React from "react";
import PostModal from "components/PostModal";

type SharePhotoActionProps = {
  prefilledOptions?: any;
};

const SharePhotoAction: React.FC<SharePhotoActionProps> = ({ prefilledOptions }) => (
  <PostModal isAButton openImageLibrary prefilledOptions={prefilledOptions} />
);

export default SharePhotoAction;
